var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Text } from '@amzn/atoz-web/Text';
import { useTranslation } from 'react-i18next';
import { useCountDownMessage } from './useCountDownMessage';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var CountDownMessage = function (_a) {
    var dropDeadline = _a.dropDeadline, _b = _a.showPreText, showPreText = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var countdownText = useCountDownMessage(dropDeadline);
    return (React.createElement(Text, { "data-testid": "count-down-header-message" },
        showPreText && (React.createElement("span", { "data-testid": "count-down-header-message-pretext" }, "".concat(t('shift_management_features_DropShiftModal_CountDownMessage_pretext'), " "))),
        countdownText && (React.createElement(React.Fragment, null,
            t('shift_management_features_DropShiftModal_CountDownMessage_youStillHave'),
            React.createElement(BoldText, { "data-testid": "dropDeadline" }, " ".concat(countdownText, " ")),
            t('shift_management_features_DropShiftModal_CountDownMessage_toDropTheShiftWithoutPenalty')))));
};
export var BoldText = styledWithTheme('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var templateObject_1;
